import React, { useState } from 'react'
import CustomInput from '../../../Components/Input/CustomInput'
import DatePicker from '../../../Components/Input/DatePicker'
import StyledFileInput from '../../../Components/Input/Input'
import { toast } from 'react-toastify'
import { SkyButton, SkyOutlinedButton } from '../../../Components/Buttons'
import { useNavigate } from 'react-router-dom'
import { getDecryptedSessionStorageVariable } from '../../../utils/encryptStorage'
import { createFleetDriver } from '../../../Services/cabapi/fleetapi'
import { AADHAR_VERIFY, VERIFY_OTP } from '../../../Services/cabapi/fleetggl'
import { useMutation } from '@apollo/client'
import {
  constructAddress,
  convertDOBToDate,
  extractNames,
} from '../../../utils/extractNames'

const AddDriver = () => {
  const navigate = useNavigate()
  const [errors, setErrors] = useState({})
  const [verifyAadhaar, { loading: submitLoading }] = useMutation(AADHAR_VERIFY)
  const [verifyAadhar, setVerifyAadhaar] = useState(false)
  const [showOtpInput, setShowOtpInput] = useState(false)
  const [verificationDetails, setVerificationDetails] = useState({
    otp: '',
    ref_id: '',
  })
  const [verifyOTP, { loading: verifyLoading }] = useMutation(VERIFY_OTP)
  const fleetId = getDecryptedSessionStorageVariable('fleetId')
  const [driverDetails, setDriverDetails] = useState({
    aadhaarNumber: '',
    firstName: '',
    middleName: '',
    lastName: '',
    mobileNumber: '',
    email: '',
    trDate: '',
    permanentAddress: '',
    birthDate: '',
    aadhaarPhotoUrl: '',
    isAadharVerified: false,
    showVerify: false,
    otpCalled: false,
    verifyOtpCalled: false,
  })
  const validateDriverDetails = () => {
    const driverErrors = {} // Store validation errors here

    // Validate each field
    if (!driverDetails.aadhaarNumber)
      driverErrors.DriverAadhaarNumber = 'Aadhar number is required *'
    if (!driverDetails.firstName)
      driverErrors.DriverfirstName = 'Driver first name is required *'

    if (!driverDetails.middleName)
      driverErrors.DrivermiddleName = 'Driver middle name is required *'

    if (!driverDetails.lastName)
      driverErrors.DriverlastName = 'Driver last name is required *'

    if (!driverDetails.mobileNumber)
      driverErrors.DrivermobileNumber = 'Driver mobile number is required *'

    if (!driverDetails.email)
      driverErrors.Driveremail = 'Driver email is required *'

    if (!driverDetails.permanentAddress)
      driverErrors.DriverPermanentAddress =
        'Driver permanent address is required *'

    if (!driverDetails.birthDate)
      driverErrors.DriverBirthDate = 'Driver date of birth is required *'

    if (!files.aadhaar_front)
      driverErrors.Driveraadhaar_front = 'This field is required *'

    if (!files.aadhaar_back)
      driverErrors.Driveraadhaar_back = 'This field is required *'

    if (!driverDetails.trDate)
      driverErrors.DrivertrExpiryDate = 'Tr ExpiryDate is required *'

    if (!files.licence_front)
      driverErrors.Driverlicence_front = 'This field is required *'

    if (!files.licence_back)
      driverErrors.Driverlicence_back = 'This field is required *'

    if (!files.police_verification)
      driverErrors.Driverpolice_verification =
        'Driver police verification is required *'

    // Set errors if they exist
    setErrors(driverErrors)

    // Return true if there are no errors, otherwise false
    return Object.keys(driverErrors).length === 0
  }

  const handleDriverInputChange = (fieldName, text) => {
    setDriverDetails((prevState) => ({
      ...prevState,
      [fieldName]: text,
    }))
  }
  const [files, setFiles] = useState({
    licence_front: null,
    licence_back: null,
    aadhaar_front: null,
    aadhaar_back: null,
    police_verification: null,
  })
  const handleFileChange = (e) => {
    setFiles({ ...files, [e.target.name]: e.target.files[0] })
  }

  const handleVerifyAadhaar = async (index) => {
    if (driverDetails?.otpCalled) {
      toast.warn('OTP already sent')
      return
    }
    const aadhaarNumber = driverDetails?.aadhaarNumber ?? ''
    await verifyAadhaar({ variables: { aadhaarNumber: aadhaarNumber ?? '' } })
      .then((res) => {
        const verifyAadhaarResponse = JSON.parse(res.data.verifyAadhaar)
        const status = verifyAadhaarResponse.status
        if (
          status === 'SUCCESS' ||
          verifyAadhaarResponse?.message == 'OTP sent successfully'
        ) {
          setShowOtpInput(true)
          toast.success('OTP sent successfully')
          setVerificationDetails((prevState) => ({
            ...prevState,
            ref_id: verifyAadhaarResponse.ref_id,
          }))
          setDriverDetails((prev) => ({
            ...prev,
            otpCalled: true,
            showVerify: true,
          }))
        }
      })
      .catch((error) => {
        console.log('error', error)
        toast.error(error.message)
      })
  }
  const handleVerifyOtp = async () => {
    if (driverDetails?.verifyOtpCalled) {
      toast.warn('OTP has already been verified')
      return
    }
    await verifyOTP({
      variables: verificationDetails,
      fetchPolicy: 'network-only',
    })
      .then((res) => {
        if (res?.data) {
          const verifyOTPData = JSON.parse(res?.data?.verifyOTP)
          const status = verifyOTPData?.status
          if (status === 'VALID') {
            toast.success('OTP verified successfully')
            setVerifyAadhaar(true)
            const data = verifyOTPData
            const { firstName, middleName, lastName } = extractNames(data?.name)
            setDriverDetails((prev) => ({
              ...prev,
              firstName: firstName,
              middleName: middleName,
              lastName: lastName,
              birthDate: convertDOBToDate(data?.dob),
              permanentAddress: constructAddress(data),
              aadhaarPhotoUrl: data?.photo_link,
              isAadhaarVerified: true,
              verifyOtpCalled: true,
              showVerify: false,
            }))
          }
        }
      })
      .catch((error) => {
        console.log('error', error)
        toast.error(error.message)
      })
  }

  const handleSubmit = async () => {
    if (!verifyAadhar) {
      toast.error('Verify aadhaar number')
      return
    }
    if (!validateDriverDetails()) {
      return
    }
    try {
      const data = new FormData()
      Object.entries(driverDetails).forEach(([key, value]) => {
        if (
          key !== 'isAadharVerified' &&
          key !== 'showVerify' &&
          key !== 'optCalled' &&
          key !== 'verifyOtpCalled'
        ) {
          data.append(key, value)
        }
      })
      data.append('fleetOwnerId', fleetId)
      Object.entries(files).forEach(([key, file]) => {
        if (file) {
          data.append(key, file)
        }
      })
      await createFleetDriver(data).then((res) => {
        toast.success('driver registered successfully')
        navigate(-1)
      })
    } catch (error) {
      console.log('error', error)
      toast.error('failed to register driver')
    }
  }
  return (
    <div className="flex justify-center w-full">
      <div className="bg-white w-full shadow-lg p-4 my-4 sm:w-[90%] xl:w-[100%]">
        <div className="flex flex-start">
          <SkyOutlinedButton label={'Back'} onClick={() => navigate(-1)} />
        </div>
        <h2 className="text-xl font-bold text-center">Add Driver</h2>
        <div className="mt-2">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
            <div>
              <CustomInput
                placeholderValue={'Enter Aadhaar Number'}
                labelValue={'Aadhar Number'}
                required
                disable={driverDetails?.isAadharVerified}
                name={`aadharNumber`}
                value={driverDetails?.aadhaarNumber || ''}
                formatAadharNumber
                onChange={(text) => {
                  handleDriverInputChange('aadhaarNumber', text)
                }}
              />
              {errors?.DriverAadhaarNumber && (
                <small className="text-red-500">
                  {errors?.DriverAadhaarNumber}
                </small>
              )}
              <div className="mt-3">
                {submitLoading ? (
                  <div className="w-6 h-6 border-4 border-t-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                ) : (
                  !driverDetails?.isAadharVerified &&
                  !showOtpInput && (
                    <SkyButton
                      type="button"
                      label={'Submit'}
                      onClick={handleVerifyAadhaar}
                    />
                  )
                )}
              </div>
            </div>
            {driverDetails?.showVerify && (
              <div>
                <div>
                  <CustomInput
                    labelValue={'Verify Otp'}
                    placeholderValue={'Enter Otp'}
                    required
                    formatVerifyOtp
                    name={`otp`}
                    value={verificationDetails.otp || ''}
                    onChange={(text) =>
                      setVerificationDetails((prevState) => ({
                        ...prevState,
                        otp: text,
                      }))
                    }
                  />
                  {verifyLoading ? (
                    <div className="w-6 h-6 border-4 border-t-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                  ) : (
                    <div className="mt-3">
                      <SkyButton
                        label={'Verify Otp'}
                        onClick={() => {
                          handleVerifyOtp()
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
            <div>
              <CustomInput
                placeholderValue={'First Name'}
                labelValue={'First Name'}
                required
                disable={true}
                name={`firstname`}
                value={driverDetails?.firstName || ''}
                onChange={(text) => handleDriverInputChange('firstName', text)}
              />
              {errors?.DriverfirstName && (
                <small className="text-red-500">
                  {errors?.DriverfirstName}
                </small>
              )}
            </div>
            <div>
              <CustomInput
                placeholderValue={'Middle Name'}
                labelValue={'Middle Name'}
                required
                disable={true}
                name={`middlename`}
                value={driverDetails?.middleName || ''}
                onChange={(text) => handleDriverInputChange('middleName', text)}
              />
              {errors?.DrivermiddleName && (
                <small className="text-red-500">
                  {errors?.DrivermiddleName}
                </small>
              )}
            </div>
            <div>
              <CustomInput
                placeholderValue={'Last Name'}
                labelValue={'Last Name'}
                required
                disable={true}
                name={`lastname`}
                value={driverDetails?.lastName || ''}
                onChange={(text) => handleDriverInputChange('lastName', text)}
              />
              {errors?.DriverlastName && (
                <small className="text-red-500">{errors?.DriverlastName}</small>
              )}
            </div>
          </div>

          {/* Second Row (Contact Info) */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
            <div>
              <CustomInput
                formatMobileNumber={true}
                placeholderValue={'Mobile Number'}
                labelValue={'Mobile Number'}
                inputtype={'tel'}
                required
                name={`mobilenumber`}
                value={driverDetails?.mobileNumber || ''}
                onChange={(text) =>
                  handleDriverInputChange('mobileNumber', text)
                }
              />
              {errors?.DrivermobileNumber && (
                <small className="text-red-500">
                  {errors?.DrivermobileNumber}
                </small>
              )}
            </div>
            <div>
              <CustomInput
                placeholderValue={'Email'}
                labelValue={'Email'}
                name={`email`}
                inputtype={'email'}
                value={driverDetails?.email || ''}
                onChange={(text) => handleDriverInputChange('email', text)}
              />
              {errors?.Driveremail && (
                <small className="text-red-500">{errors?.Driveremail}</small>
              )}
            </div>
            <div>
              <CustomInput
                placeholderValue={'Permanent Address'}
                labelValue={'Permanent Address'}
                required
                disable={true}
                name={`permanentaddress`}
                value={driverDetails?.permanentAddress || ''}
                onChange={(text) =>
                  handleDriverInputChange('permanentAddress', text)
                }
              />
              {errors?.DriverPermanentAddress && (
                <small className="text-red-500">
                  {errors?.DriverPermanentAddress}
                </small>
              )}
            </div>
          </div>

          {/* Third Row (Birth Date, Files Upload) */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
            <div>
              <DatePicker
                labelValue="Birth Date"
                selected={driverDetails?.birthDate}
                onChange={(value) => {
                  handleDriverInputChange('birthDate', value)
                }}
                disable={true}
              />
              {errors?.DriverfirstName && (
                <small className="text-red-500">
                  {errors?.DriverBirthDate}
                </small>
              )}
            </div>
            <div>
              <div className="flex gap-1 w-full flex-col text-start max-w-96">
                <label className="text-stone-700 text-xs font-semibold mt-2">
                  Aadharcard Front
                </label>
                <StyledFileInput
                  name={'aadhaar_front'}
                  onChange={handleFileChange}
                />
                {errors?.Driveraadhaar_front && (
                  <small className="text-red-500">
                    {errors?.Driveraadhaar_front}
                  </small>
                )}
              </div>
            </div>
            <div>
              <div className="flex gap-1 w-full flex-col text-start max-w-96">
                <label className="text-stone-700 text-xs font-semibold mt-2">
                  Aadharcard Back
                </label>
                <StyledFileInput
                  name={'aadhaar_back'}
                  onChange={handleFileChange}
                />
                {driverDetails?.aadhaar_back?.name && (
                  <div className="mt-2 text-sm text-stone- justify-between flex">
                    <span>{driverDetails?.aadhaar_back?.name}</span>
                  </div>
                )}
                {errors?.Driveraadhaar_back && (
                  <small className="text-red-500">
                    {errors?.Driveraadhaar_back}
                  </small>
                )}
              </div>
            </div>
          </div>

          {/* Fourth Row (TR Expiry, Driving License) */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
            <div>
              <DatePicker
                labelValue="Tr Expiry Date"
                selected={driverDetails?.trDate}
                onChange={(value) => {
                  handleDriverInputChange('trDate', value)
                }}
                minDate={new Date().toISOString().split('T')[0]}
                maxDate={(() => {
                  const maxDate = new Date()
                  maxDate.setFullYear(maxDate.getFullYear() + 5) // Set maxDate to 1 year from today
                  return maxDate.toISOString().split('T')[0] // Return in YYYY-MM-DD format
                })()}
              />
              {errors?.DrivertrExpiryDate && (
                <small className="text-red-500">
                  {errors?.DrivertrExpiryDate}
                </small>
              )}
            </div>
            <div>
              <div className="flex gap-1 w-full flex-col text-start max-w-96">
                <label className="text-stone-700 text-xs font-semibold mt-2">
                  Driving Licence Front
                </label>
                <StyledFileInput
                  name={'licence_front'}
                  onChange={handleFileChange}
                />
                {driverDetails?.licence_front?.name && (
                  <div className="mt-2 text-sm text-stone- justify-between flex">
                    <span>{driverDetails?.licence_front?.name}</span>
                  </div>
                )}
                {errors?.Driverlicence_front && (
                  <small className="text-red-500">
                    {errors?.Driverlicence_front}
                  </small>
                )}
              </div>
            </div>
            <div className="flex gap-1 w-full flex-col text-start max-w-96">
              <label className="text-stone-700 text-xs font-semibold mt-2">
                Driving Licence Back
              </label>
              <StyledFileInput
                name={'licence_back'}
                onChange={handleFileChange}
              />
              {errors?.Driverlicence_back && (
                <small className="text-red-500">
                  {errors?.Driverlicence_back}
                </small>
              )}
            </div>
          </div>

          {/* Fifth Row (Police Verification File Upload) */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2">
            <div className="flex gap-1 w-full flex-col text-start max-w-96">
              <label className="text-stone-700 text-xs font-semibold mt-2">
                Police Verification
              </label>
              <StyledFileInput
                name={'police_verification'}
                onChange={handleFileChange}
              />
              {errors?.Driverpolice_verification && (
                <small className="text-red-500">
                  {errors?.Driverpolice_verification}
                </small>
              )}
            </div>
          </div>
        </div>
        <div className=" flex gap-4 my-2">
          <SkyButton label={'Submit'} onClick={handleSubmit} />

          <SkyOutlinedButton label={'Cancel'} onClick={() => navigate(-1)} />
        </div>
      </div>
    </div>
  )
}

export default AddDriver
